import React from "react";
import classNames from "classnames";

import useFilters from "hooks/useFilters";

import ClearIcon from "components/Icons/x.svg";

import { Facet } from "./FilteredGrid";

export const FilterChip = ({
  className,
  onClick: onClickProp,
  facet,
}: {
  className?: string;
  // * NOTE: This is not an additive onClick.
  // * This rather overrides the baked in behavior of this component.
  // * See ProductFilterView for primary usage of this.
  onClick?: (facet: Facet) => void;
  facet: Facet;
}) => {
  const { toggleFilter } = useFilters();

  const onClickHandler = () =>
    onClickProp
      ? onClickProp(facet)
      : toggleFilter({ [facet.key]: facet.value });

  return (
    <button
      className={classNames(
        "flex items-center text-xs font-bold py-xs px-sm bg-green-20 border border-green-40 rounded flex-shrink-0 capitalize",
        className
      )}
      onClick={onClickHandler}
    >
      <span className="mr-xs text-left truncate-lines max-w-[200px]">
        {facet.label}
      </span>
      <ClearIcon height="12" width="12" />
    </button>
  );
};
